/*=========================================================================================
  File Name: actions.js
  Namespace: reporting
  Description: Vuex Store - IFrame actions
==========================================================================================*/
import {
  listReportings, downloadReport, createReporting
} from '@/services/reporting.service'

const actions = {
  async getRatingReportsAction({
    commit
  }, payload = {}) {
    const response = await listReportings({
      type: "rating",
      ...payload
    })
    if (response) {
      commit('STORE_RATING_REPORTS', response)
    }
    return response
  },
  async createRatingReportAction(store, {
    type,
    model_id,
    model_type,
    from,
    to
  }) {
    const response = await createReporting({
      type,
      model_id,
      model_type,
      from,
      to
    })
    return response
  },
  async downloadReportAction(store, {
    reportId
  }) {
    const response = await downloadReport({
      reportId
    })
    return response
  }
}

export default actions
